import { useQuery } from '@tanstack/react-query'
import { TSpace } from '@valuecase/common'
import { spacesApi } from '@/api/spacesApi/spacesAPIclient'

export const useReadSpace = (spaceId?: string) => {
  return useQuery<TSpace & { data: any }>({
    queryKey: ['space', spaceId],
    queryFn: async () => {
      if (!spaceId) return null
      const response = await spacesApi.get(`/spaces/byRootNodeId/${spaceId}`)
      return response.data
    },
    enabled: !!spaceId,
  })
}
